import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { EmptyValue } from '@atlassian/jira-issue-view-common-styles';

import type { ParentFieldType } from '../types';

import EpicLinkExistsMessage from './epic-link-exists-message';

type Props = {
	value: ParentFieldType;
	showError: boolean;
	noValueText: string;
};

const ParentViewField = (props: Props) => {
	const { showError, value, noValueText } = props;
	if (showError) {
		return <EpicLinkExistsMessage />;
	}
	if (value.data) {
		const {
			key,
			summary,
			issueType: { iconUrl },
			url,
		} = value.data;

		return (
			<Container>
				<Icon src={iconUrl} />
				<Link href={url} target="_blank">
					{key}
				</Link>
				<Summary>{summary}</Summary>
			</Container>
		);
	}
	return <EmptyValue>{noValueText}</EmptyValue>;
};

export default ParentViewField;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	flexDirection: 'row',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Link = styled.a({
	marginRight: token('space.100', '8px'),
	cursor: 'pointer',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Summary = styled.div({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled.img({
	marginRight: token('space.100', '8px'),
});
